<template>
  <div>
    <div class="card">
      <div class="card-body">
        <userList :properties="properties"/>
      </div>
    </div>
  </div>
</template>
<script>
import userList from '@/components/custom/userList'
import store from 'store'

export default {
  name: 'ManagementArea',
  components: { userList },
  data() {
    return {
      properties: {},
    }
  },
  computed: {
  },
  methods: {},
  created() {
    const academicModule = JSON.parse(store.get('userData')).school.academicModule
    this.properties = {
      databaseReport: true,
      create: true,
      hasColumns: true,
      columns: {
        cc: true,
        grade: true,
        balance: true,
        actions: true,
      },
      searchOptions: {
        role: true,
        cc: true,
        name: true,
        lastName: true,
        grade: true,
        email: true,
      },
      hasActions: true,
      actions: {
        information: true,
        edit: true,
        rechargeBalance: true,
        rechargeCombos: true,
        passwordReset: true,
        startEnrollement: academicModule || false,
      },
      user: {
        downloadEnrollmentSheet: true,
        deleteUser: true,
      },
    }
  },
}
</script>
